import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import css from './ApxViewReport.module.css'
import cssACM from './AccountManagement.module.css'
import cssCommon from './Common.module.css'
import logo from "./../Images/APX.png";
import Grid from '@material-ui/core/Grid';
import MenuAccountManagement from '../Components/MenuAccountManagement';
import DocumentRequest from './DocumentRequest';
import ReTier from './ReTier';
import { AccountManagementMenu } from './../Enums/Enums';
import HistoryGrid from './HistoryGrid'
import ManageAccount from './ManageAccount';
import Tools from './Tools';


class AccountManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModule: AccountManagementMenu.ReTier,
      firmName: "",
      count: 0
    }

    this.props.data.APX.AccountManagementCallback = this.menuChange.bind(this);
    this.props.data.Service.FirmNameCallback = this.firmName.bind(this);
    this.props.data.AccountManagement.SetCount = this.setCount.bind(this);
  }

  menuChange(value) {
    this.props.data.Service.GetAccountManagementHistoryListCallback([]);
    this.setState({ showModule: value, firmName: "" });
  }

  firmName(firmName) {
    this.setState({ firmName: firmName });
  }

  setCount(count) {
    this.setState({ count: count });
  }

  render() {
    return (
      <div>
        <Paper className={this.state.showModule === AccountManagementMenu.DocumentRequest ? cssACM.paper : cssACM.paper_tier} elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <img src={logo} alt="logo" className={css.logo}></img>
            </Grid>
            <Grid item xs={2}>
              <div className={cssACM.header}>Account Managment</div>
            </Grid>
            <Grid item xs={6}>
              <MenuAccountManagement data={this.props.data}></MenuAccountManagement>
            </Grid>
            <Grid item xs={2}>
              <Tools data={this.props.data} className={cssACM.tools}></Tools>
            </Grid>
          </Grid>
          <div className={cssCommon.separator}></div>
          {this.state.showModule === AccountManagementMenu.DocumentRequest ? <DocumentRequest data={this.props.data}></DocumentRequest> : null}
          {this.state.showModule === AccountManagementMenu.ReTier ? <ReTier data={this.props.data}></ReTier> : null}
          {this.state.showModule === AccountManagementMenu.Manage ? <ManageAccount data={this.props.data}></ManageAccount> : null}
        </Paper>
        {this.state.showModule !== AccountManagementMenu.Manage ?
          <Paper className={cssACM.paper_grid} elevation={3}>
            <div>
              <div className={cssACM.grid_label}>History - {this.state.firmName}</div>
              <div className={cssACM.grid_count}>{this.state.count}</div>
            </div>
            <HistoryGrid data={this.props.data}></HistoryGrid>
          </Paper> : null}
      </div>
    );
  }
}

export default AccountManagement;